var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isValidationComplete
    ? _c(
        "div",
        {
          staticClass:
            "reset-password-container is-flex is-align-items-center is-justify-content-center",
        },
        [
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "control mb-5 is-flex is-justify-content-center" },
              [
                _c("img", {
                  staticStyle: { "max-height": "2.25rem" },
                  attrs: {
                    src: _vm.logoImgPath,
                    alt: "Flexiquote Logo",
                    title: "Flexiquote Logo",
                  },
                }),
              ]
            ),
            _vm._m(0),
            !_vm.isResetComplete && !_vm.hasValidationError
              ? _c("div", [
                  _c("div", { staticClass: "control mb-6" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label is-required-label" }, [
                        _vm._v("New Password"),
                      ]),
                      _c("div", { staticClass: "field has-addons" }, [
                        _c("div", { staticClass: "control is-expanded" }, [
                          (_vm.newPasswordVisible ? "text" : "password") ===
                          "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newPassword,
                                    expression: "newPassword",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  placeholder: "New Password",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.newPassword)
                                    ? _vm._i(_vm.newPassword, null) > -1
                                    : _vm.newPassword,
                                },
                                on: {
                                  blur: _vm.validateNewPassword,
                                  change: function ($event) {
                                    var $$a = _vm.newPassword,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.newPassword = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.newPassword = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.newPassword = $$c
                                    }
                                  },
                                },
                              })
                            : (_vm.newPasswordVisible ? "text" : "password") ===
                              "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newPassword,
                                    expression: "newPassword",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  placeholder: "New Password",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.newPassword, null),
                                },
                                on: {
                                  blur: _vm.validateNewPassword,
                                  change: function ($event) {
                                    _vm.newPassword = null
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newPassword,
                                    expression: "newPassword",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  placeholder: "New Password",
                                  type: _vm.newPasswordVisible
                                    ? "text"
                                    : "password",
                                },
                                domProps: { value: _vm.newPassword },
                                on: {
                                  blur: _vm.validateNewPassword,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.newPassword = $event.target.value
                                  },
                                },
                              }),
                          _vm.$v.newPassword.$dirty &&
                          !_vm.$v.newPassword.required
                            ? _c(
                                "span",
                                { staticClass: "help is-danger ml-1" },
                                [_vm._v("Required")]
                              )
                            : _vm._e(),
                          _vm.$v.newPassword.$dirty &&
                          !_vm.$v.newPassword.validatedNewPassword &&
                          _vm.$v.newPassword.required
                            ? _c(
                                "span",
                                { staticClass: "help is-danger ml-1" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.passwordValidationMessage) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c("p", { staticClass: "control" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              on: {
                                click: function ($event) {
                                  _vm.newPasswordVisible =
                                    !_vm.newPasswordVisible
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "icon is-small is-right" },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-18px",
                                    class: _vm.newPasswordVisible
                                      ? "mdi-eye-outline"
                                      : "mdi-eye-off-outline",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label is-required-label" }, [
                        _vm._v("Confirm New Password"),
                      ]),
                      _c("div", { staticClass: "field has-addons" }, [
                        _c("div", { staticClass: "control is-expanded" }, [
                          (_vm.confirmedPasswordVisible
                            ? "text"
                            : "password") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.confirmedPassword,
                                    expression: "confirmedPassword",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  placeholder: "Confirm New Password",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.confirmedPassword)
                                    ? _vm._i(_vm.confirmedPassword, null) > -1
                                    : _vm.confirmedPassword,
                                },
                                on: {
                                  blur: _vm.validateConfirmedPassword,
                                  change: function ($event) {
                                    var $$a = _vm.confirmedPassword,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.confirmedPassword = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.confirmedPassword = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.confirmedPassword = $$c
                                    }
                                  },
                                },
                              })
                            : (_vm.confirmedPasswordVisible
                                ? "text"
                                : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.confirmedPassword,
                                    expression: "confirmedPassword",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  placeholder: "Confirm New Password",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.confirmedPassword, null),
                                },
                                on: {
                                  blur: _vm.validateConfirmedPassword,
                                  change: function ($event) {
                                    _vm.confirmedPassword = null
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.confirmedPassword,
                                    expression: "confirmedPassword",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  placeholder: "Confirm New Password",
                                  type: _vm.confirmedPasswordVisible
                                    ? "text"
                                    : "password",
                                },
                                domProps: { value: _vm.confirmedPassword },
                                on: {
                                  blur: _vm.validateConfirmedPassword,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.confirmedPassword = $event.target.value
                                  },
                                },
                              }),
                          _vm.$v.confirmedPassword.$dirty &&
                          !_vm.$v.confirmedPassword.required
                            ? _c(
                                "span",
                                { staticClass: "help is-danger ml-1" },
                                [_vm._v("Required")]
                              )
                            : _vm._e(),
                          _vm.$v.confirmedPassword.$dirty &&
                          !_vm.$v.confirmedPassword.matchNewPassword &&
                          _vm.$v.confirmedPassword.required
                            ? _c(
                                "span",
                                { staticClass: "help is-danger ml-1" },
                                [
                                  _vm._v(
                                    "Please make sure your passwords match."
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c("p", { staticClass: "control" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              on: {
                                click: function ($event) {
                                  _vm.confirmedPasswordVisible =
                                    !_vm.confirmedPasswordVisible
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "icon is-small is-right" },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-18px",
                                    class: _vm.confirmedPasswordVisible
                                      ? "mdi-eye-outline"
                                      : "mdi-eye-off-outline",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "control mb-2 is-flex is-justify-content-end",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary",
                          on: { click: _vm.forgotPasswordReset },
                        },
                        [_vm._v("Confirm")]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm.isResetComplete ||
            (_vm.isValidationComplete && _vm.hasValidationError)
              ? _c(
                  "div",
                  [
                    _c(
                      "notification-box",
                      {
                        staticClass: "mb-6",
                        attrs: { type: _vm.notificationType },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "is-size-7",
                            attrs: { slot: "text-content" },
                            slot: "text-content",
                          },
                          [_vm._v(_vm._s(_vm.message))]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "control is-flex is-justify-content-end" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            on: { click: _vm.cancel },
                          },
                          [_vm._m(1), _vm._v(" Back to login ")]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "control mb-6" }, [
      _c("h4", { staticClass: "has-text-weight-medium is-size-5" }, [
        _vm._v("Set new password"),
      ]),
      _c("p", { staticClass: "has-text-grey is-size-7" }, [
        _vm._v(
          " Must be at least 8 characters, have at least one symbol, one number, one uppercase and one lowercase letter. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon mr-1" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-arrow-left" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }